export function parseEnteprisesWithSignPolicy(policies: string): Map<string, string> {
  const policiesArray = policies.split(' ');
  const enterprisesWithPolicies = new Map<string, string>();

  policiesArray.forEach(policy => {
    const enterpriseWithPolicy = policy.split(':');
    if (enterpriseWithPolicy.length < 2) {
      return;
    }
    const [domain, signPolicy] = enterpriseWithPolicy;
    enterprisesWithPolicies.set(domain, signPolicy);
  });

  return enterprisesWithPolicies;
}
